import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { Button, ModalFooter, ModalHeader, ModalTitle, useModal } from '@/components/base'

export function ConfirmModal({ onSubmit }: { onSubmit: () => void }) {
  const { t } = useTranslation()
  const { closeModal } = useModal()
  return (
    <>
      <ModalHeader className={'p-4'}>
        <ModalTitle>{t('orderAppeal:details.modal.title')}</ModalTitle>
      </ModalHeader>
      <View className={'px-4 py-2'}>
        <Text className={'text-sm text-text-secondary'}>{t('orderAppeal:details.modal.content')}</Text>
      </View>
      <ModalFooter>
        <Button className={'flex-1'} variant={'outline'} size={'md'} onPress={closeModal}>
          {t('orderAppeal:details.modal.cancel')}
        </Button>
        <Button className={'flex-1'} size={'md'} onPress={onSubmit}>
          {t('orderAppeal:details.modal.confirm')}
        </Button>
      </ModalFooter>
    </>
  )
}
